import styled from "styled-components"

const Count = styled.div`
  background-color: ${({backgroundColor, theme}) => backgroundColor || theme.colors.brand.primaryColour || theme.colors.utility.subdued};
  color: ${({textColor, theme}) => textColor || theme.colors.brand.textColour || theme.colors.utility.white};
  display: inline-block;
  padding: 2px 10px;
  border-radius: 15px;
  margin-left: 10px;
  position: relative;
  bottom: 5px;
  font-size: 12px;
`

export default Count
